import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-image-register',
  templateUrl: './image-register.component.html',
  styleUrls: ['./image-register.component.scss']
})
export class ImageRegisterComponent implements OnInit {
  @Input() avatarPhoto: any = '../../../../assets/images/generic-profile-picture.png';
  @Output() ImageFormData = new EventEmitter();
  selectedFile: File = null;

  constructor() { }

  ngOnInit() {
  }

  /*
    Emit uma variavel contendo o valor em do tipo
    FormData para uma variavel inscrita
  */
  onChangeImg(file): void {
    this.toBase64(file.files[0]);
    this.selectedFile = file.files[0];
    this.ImageFormData.emit(
      this.setPhoto(this.selectedFile)
    );
  }

  toBase64(file): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event: any) => {
      this.avatarPhoto = reader.result;
    };
  }

  setPhoto(file): FormData {
    const fd = new FormData();
    fd.append('file', file);
    return fd;
  }
}
